<template>
  <div v-if="isUnderMaintenance" class="maintenance-screen">
    <img src="@/assets/img/logo.svg" alt="Logo" class="logo" />
    <h1>メンテナンス中</h1>
    <p>お客様各位</p>
    <div class="maintenance-info">
      <p>只今、メンテナンス中のためご利用いただけません。</p>
      <p>誠に申し訳ありませんが、メンテナンス終了まで今しばらくお待ちください。</p>
      <p class="maintenance-duration">メンテナンス期間</p>
      <p class="maintenance-info"><u>2024年12月18日（水）0:00～6:00（日本時間）</u></p>
    </div>
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script>
import { MaintenanceService } from '@/services/MaintenanceService';

export default {
  data() {
    return {
      isUnderMaintenance: MaintenanceService.isUnderMaintenance(),
    };
  },
};
</script>

<style scoped>
.maintenance-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0;
  text-align: center;
  padding: 20px;
}

.logo {
  width: 350px; /* ロゴのサイズ */
  margin-bottom: 20px; /* ロゴの下のスペース */
}

h1 {
  font-size: 2.5rem;
  color: #961e23; /* テキストの色 */
  margin-bottom: 25px !important;
}

p {
  font-size: 1.2rem;
  color: #333; /* テキストの色 */
  margin: 5px 0;
}

.maintenance-duration {
  font-size: 1.5rem;
  color: #333; /* セカンダリテキストの色 */
  margin-top: 30px; /* 上部のスペース */
}

.maintenance-info {
  margin-top: 10px;
  font-size: 1rem;
  color: #666; /* セカンダリテキストの色 */
}
</style> 